import { type MouseEventHandler, memo } from 'react';

import { XIcon } from '@air/design-icons';
import { IconButton } from '@air/primitive-icon-button';

export type WorkspaceAgentPreviewCardCloseButtonProps = {
  onClose: () => void;
  /** A composer host guards the press so the editor keeps focus and selection. */
  onMouseDown?: MouseEventHandler<HTMLButtonElement>;
};

/**
 * `IconButton` at its ghost gray base, since the chrome here is the overlay's rather than the
 * primitive's: a translucent ground and a shadow so the glyph stays legible over any still. The
 * primitive ships no focus style, so the panel's ring is restated. Named "Close preview": a reader
 * lands here first on open.
 */
export const WorkspaceAgentPreviewCardCloseButton = memo(
  ({ onClose, onMouseDown }: WorkspaceAgentPreviewCardCloseButtonProps) => (
    <IconButton
      appearance="ghost"
      className="rounded-8 ads:bg-base/90 bg-gray-1/90 ads:text-icon-default text-gray-11 shadow-s ads:hover:bg-base hover:bg-gray-1 ads:hover:text-icon-emphasis hover:text-gray-12 focus-visible:outline-none ads:focus-visible:ring-focus focus-visible:ring-2 focus-visible:ring-altitude-9 focus-visible:ads:ring-offset-ads-gray-1 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-1 forced-colors:focus-visible:outline forced-colors:focus-visible:outline-2"
      color="gray"
      data-testid="WORKSPACE_AGENT_PREVIEW_CARD_CLOSE"
      // The primitive renders this visually hidden as the button's only name, so no `aria-label` beside it.
      label="Close preview"
      onClick={onClose}
      onMouseDown={onMouseDown}
      size="small"
    >
      <XIcon size={14} />
    </IconButton>
  ),
);

WorkspaceAgentPreviewCardCloseButton.displayName = 'WorkspaceAgentPreviewCardCloseButton';
